import { useState } from 'react'
import { BrowserRouter as Router, Routes, Route, Link, useLocation  } from "react-router-dom";
import MainPage from '@pages/main';
import { Toaster, toast } from 'sonner';
import Order from '@pages/order';
import LegalPage from '@pages/legal';
import LegalCase1Page from '@pages/legal/cases/1';
import LegalCase2Page from '@pages/legal/cases/2';
import LegalCase3Page from '@pages/legal/cases/3';
import LegalCase4Page from '@pages/legal/cases/4';
import LegalCase5Page from '@pages/legal/cases/5';
import LegalCase6Page from '@pages/legal/cases/6';

function App() {
  return (
  <Router basename="/">
    <Toaster position="bottom-right" richColors expand={false} />
    <Routes>
      <Route path='*' element={<MainPage />} />
      <Route path='/order/:id' element={<Order/>} />
      <Route path='/legal' element={<LegalPage />} />
      <Route path='/legal/1' element={<LegalCase1Page />} />
      <Route path='/legal/2' element={<LegalCase2Page />} />
      <Route path='/legal/3' element={<LegalCase3Page />} />
      <Route path='/legal/4' element={<LegalCase4Page />} />
      <Route path='/legal/5' element={<LegalCase5Page />} />
      <Route path='/legal/6' element={<LegalCase6Page />} />
      <Route path='/' element={<MainPage />} />
    </Routes>
  </Router>
  )
}

export default App
